import { Tag } from 'antd';

export const STATUS_OPTIONS = [
  { value: '', label: 'Tất cả trạng thái' },
  { value: 'PENDING_REVIEW', label: 'Chờ duyệt' },
  { value: 'NEEDS_CHANGES', label: 'Cần bổ sung' },
  { value: 'APPROVED', label: 'Đã duyệt' },
  { value: 'REJECTED', label: 'Từ chối' },
  { value: 'DRAFT', label: 'Bản nháp' },
  { value: 'SUSPENDED', label: 'Tạm ngưng' },
];

export const STATUS_META = {
  DRAFT: ['Bản nháp', 'default'],
  PENDING_REVIEW: ['Chờ duyệt', 'processing'],
  NEEDS_CHANGES: ['Cần bổ sung', 'warning'],
  APPROVED: ['Đã duyệt', 'success'],
  REJECTED: ['Từ chối', 'error'],
  SUSPENDED: ['Tạm ngưng', 'default'],
};

export const DOCUMENT_LABELS = {
  CCCD_FRONT: 'CCCD mặt trước',
  CCCD_BACK: 'CCCD mặt sau',
  SELFIE: 'Ảnh chân dung',
  DRIVER_LICENSE: 'Giấy phép lái xe',
  VEHICLE_REGISTRATION: 'Đăng ký xe',
  VEHICLE_FRONT: 'Ảnh xe mặt trước',
  VEHICLE_BACK: 'Ảnh xe mặt sau',
  INSPECTION: 'Đăng kiểm',
  INSURANCE: 'Bảo hiểm',
};

export const VEHICLE_TYPE_LABELS = {
  CAR: 'Ô tô',
  MOTORBIKE: 'Xe máy',
};

export const getRideKycErrorMessage = (error) => error?.response?.data?.message
  || error?.response?.data?.reason
  || 'Không thể xử lý yêu cầu KYC';

export const getRideKycStatusLabel = (status) => STATUS_META[status]?.[0] || status || '—';

export function RideKycStatusTag({ status }) {
  const [label, color] = STATUS_META[status] || [status || 'Không rõ', 'default'];
  return <Tag color={color}>{label}</Tag>;
}
